module.exports = __webpack_public_path__ + "static/media/match-preview.e1f05a97.png";